import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appNumericInput]'
})
export class NumericInputDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const initialValue = input.value;
    console.log('llegue2');
    // Filtrar el valor ingresado y permitir solo números
    const numericValue = initialValue.replace(/[^0-9]/g, '');

    // Actualizar el valor en el input
    input.value = numericValue;
  }

  @HostListener('keydown', ['$event']) onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    console.log('llegue');
    // Permitir solo números y las teclas de control (como retroceso o suprimir)
    if (!event.key.match(/^[0-9]$/) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  private isControlKey(event: KeyboardEvent): boolean {
    return ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key);
  }

}
